import React from "react";

function CasualContactKn() {
  return (
    <div className="body-content">
      <div class="letters-color-section">
        <div class="main_header">ಬಸ್ ಅನ್ನು ಬಾಡಿಗೆಗೆ ಪಡೆಯಿರಿ</div>
        <div class="main-container">
          <div class="main-header-bus">
            <span class="new-bus">ಹೊಸ </span>ನವೀಕರಿಸಿದ ಮಾಹಿತಿಯನ್ನು
            ksrtc.karnataka.gov.in ನಲ್ಲಿ ಪ್ರಕಟಿಸಲಾಗಿದೆ ನೋಡಲು
            <a class="href-link" href="">
              ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CasualContactKn;
